export default __webpack_public_path__ + "static/media/icon_subscribe.4acefbbd.svg";